import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'
import {
  DASHBOARD_ADD_PAYEES_QUERY,
  DASHBOARD_SEARCH_QUERY,
  SEARCH_QUERY_REST_QUERY_GQL
} from '../../../graphql/query/payees/add/payees.graphql'
import { getSearchProcessedData } from '../../../utils/processData'

export const useDashboardService = () => {
  const [
    loadApi,
    {
      called = true,
      loading: gqlLoading = true,
      error: gqlError = null,
      data: gqlData = null
    }
  ] = useLazyQuery(DASHBOARD_ADD_PAYEES_QUERY)

  /**
   * Always use lazy graphql query react hook to make API call.
   * decide to make API call or not based on the components prop(TBD) value
   * if the prop value is boolean false make call to loadApi else skip the call
   * note: this useEffect executes only once when the component is mount.
   */
  useEffect(() => {
    loadApi()
  }, [])

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */
  useEffect(() => {
    if (gqlData?.paymentsDashboard?.paymentsDashboard?.payees?.length > 0) {
      const event = new CustomEvent('billpay-route', {
        detail: {
          action: 'redirect',
          path: 'payeemanagement-billpay/payees/dashboard'
        }
      })

      document?.dispatchEvent(event)
    }
  }, [gqlData, gqlLoading, gqlError])

  return { loadApi, called, loading: gqlLoading, data: gqlData }
}
export const useSearchDashboadService = (isRestAPI) => {
  // const isRestAPI = true
  // const [searchBillData, SetSearchBillData] = useState([])
  const [
    loadApi,
    {
      called = true,
      loading: gqlLoading = true,
      error: gqlError = null,
      data: gqlData = null
    }
  ] = useLazyQuery(
    isRestAPI ? SEARCH_QUERY_REST_QUERY_GQL : DASHBOARD_SEARCH_QUERY
  )
  // const error = useErrorService(gqlError)

  /**
   * Always use lazy graphql query react hook to make API call.
   * decide to make API call or not based on the components prop(TBD) value
   * if the prop value is boolean false make call to loadApi else skip the call
   * note: this useEffect executes only once when the component is mount.
   */
  // useEffect(() => {
  //   loadApi()
  // }, [])

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */
  const searchBillData = gqlData?.billpayPayeeListInquiry?.billerList?.map?.(
    (item, index) => ({
      id: index + 1,
      value: item && item.billerName,
      billerZipRequired: item && item.billerZipRequired,
      billerSiteUrl: item && item.billerSiteUrl
    })
  )

  return {
    loadApi,
    called,
    loading: gqlLoading,
    data: gqlData,
    searchBillData: isRestAPI
      ? getSearchProcessedData(gqlData?.payeeListInquiryRequest)
      : searchBillData,
    error: gqlError
  }
}
